export { formatTime };

function formatTime(time: number) {
  let m = Math.floor(time / 60);
  let s = time - m * 60;

  return `${m > 9 ? m : "0" + m}:${s > 9 ? s : "0" + s}`;
}
